import Router from 'vue-router'
import routes from './routes'

const router = new Router({
  mode: 'history',
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js